"use client";

import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Box, Typography } from "@mui/material";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";

const ComboDaysModal = ({ open, onClose }) => {
  const [prizes, setPrizes] = useState([]);
  const [active, setActive] = useState(null);

  const { data, loading, error } = useFetchWithAuth("/user/combo-widget/");

  useEffect(() => {
    if (data) {
      setPrizes(
        (data.all || []).map((p) => ({
          id: p.id,
          days: p.days_required,
          reward: p.prize_description,
        }))
      );
    }
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          background: "none",
          boxShadow: "none",
          backdropFilter: "none",
          borderRadius: 0,
          p: 0,
        },
      }}
    >
      <DialogContent
        className="rmui-card"
        sx={{
          color: "#fff",
          borderRadius: 2,
          background: "#fff",
          p: 0,
          minWidth: 700,
          boxShadow: "none",
          overflow: "visible",
          position: "relative",
          ".dark-theme &": {
            background: "#0C1427",
          },
        }}
      >
        <Box sx={{ position: "absolute", top: 12, right: 20, zIndex: 10 }}>
          <span
            style={{
              cursor: "pointer",
              fontSize: 32,
              color: "#fff",
              fontWeight: 300,
            }}
            onClick={onClose}
            className="text-black"
          >
            &times;
          </span>
        </Box>

        <Box sx={{ p: 2, width: "100%" }}>
          <Typography
            sx={{
              fontWeight: 500,
              mb: 3,
              fontSize: 18,
              display: "flex",
              alignItems: "center",
            }}
            className="text-black"
          >
            <span style={{ fontSize: 22, marginRight: 10 }}>ⓘ</span>
            Призи для операторів
          </Typography>

          {loading && <Typography>Загрузка...</Typography>}
          {error && <Typography color="error">Ошибка загрузки</Typography>}

          <Box sx={{ display: "flex", flexDirection: "row", gap: 3, mb: 3 }}>
            {prizes.map((prize, i) => (
              <Box
                key={i}
                onClick={() => setActive(i)}
                sx={{
                  flex: 1,
                  background: active === i ? "#E0E7FF" : "transparent",
                  border: "1px solid #605DFF",
                  borderRadius: 3,
                  p: 3,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  minWidth: 0,
                  minHeight: 110,
                  transition: "all 0.2s",
                  boxShadow: "none",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      mr: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                    variant="subtitle2"
                  >
                    <Box
                      sx={{
                        border: "1px solid #172036",
                        padding: "10px",
                        width: "40px",
                        height: "40px",
                        borderRadius: "5px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      {prize.days}
                    </Box>

                    <span
                      style={{
                        fontSize: 16,
                        width: "54px",
                        marginLeft: "20px",
                        overflowWrap: "break-word",
                        whiteSpace: "normal",
                        alignSelf: "center",
                        alignItems: "center",
                        display: "inline-block",
                      }}
                    >
                      Комбо днів
                    </span>
                  </Typography>
                  <Box
                    sx={{
                      ml: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 1,
                      borderRadius: 2,
                      background: "#605DFF",
                    }}
                  >
                    <Typography
                      style={{
                        fontSize: 16,
                        color: "#fff",
                      }}
                    >
                      {prize.reward}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ComboDaysModal;
